import addStaticMembersTo
import buildValues
import dev.shanty.kotwire.stimulus.Application
import dev.shanty.kotwire.stimulus.Event
import kotlin.Array
import kotlin.js.JsExport
import kotlin.reflect.KClass
import org.w3c.dom.HTMLElement

@JsExport
public interface PackingFormControllerTargetLifecycleHooks {
  public fun nameTargetConnected(element: HTMLElement) {
  }

  public fun nameTargetDisconnected(element: HTMLElement) {
  }

  public fun quantityTargetConnected(element: HTMLElement) {
  }

  public fun quantityTargetDisconnected(element: HTMLElement) {
  }

  public fun notesTargetConnected(element: HTMLElement) {
  }

  public fun notesTargetDisconnected(element: HTMLElement) {
  }
}

public fun <T : HTMLElement> PackingFormController.nameTarget(): StimulusProperty<T> =
    StimulusProperty("nameTarget")

public fun <T : HTMLElement> PackingFormController.nameTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("nameTargets")

public fun <T : HTMLElement> PackingFormController.quantityTarget(): StimulusProperty<T> =
    StimulusProperty("quantityTarget")

public fun <T : HTMLElement> PackingFormController.quantityTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("quantityTargets")

public fun <T : HTMLElement> PackingFormController.notesTarget(): StimulusProperty<T> =
    StimulusProperty("notesTarget")

public fun <T : HTMLElement> PackingFormController.notesTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("notesTargets")

public fun registerPackingFormController(stimulus: Application) {
               val clazz = PackingFormController::class
               val properties = object  {
                  // Js name needed otherwise Kotlin will mangle the name
                  @JsName("targets")
                  val targets = js("""[
  "name",
  "quantity",
  "notes",
  ]""")

                  @JsName("values")
                  val values = buildValues(
                      setOf(
                          
                      ),
                      null
                  )
                  
                  
                  
                  @JsName("classes")
                  val classes = js("[]")
              }

              val factoryFunc = clazz.js.asDynamic()

              addStaticMembersTo(factoryFunc, properties)
              val controllerName = "packingform"
              println("Registering controller packingform")

              stimulus.register(controllerName, factoryFunc)
}
